
import React from 'react';

/**
 *
 * @param { string } type arrow to use return
 *
 * @returns { jsx, string } returns arrow icon jsx for given arrow or empty string
 */
function insertArrow(type) {
  const ARROWS = {
    confirm: <i className="sa sa-angle-right u-margin-left-micro" />, // right arrow
    expand: <i className="sa sa-angle-down u-margin-left-micro" />,   // down arrow
    shrink: <i className="sa sa-angle-up u-margin-left-micro" />,     // up arrow
  };
  return ARROWS[type] || '';
}

/**
 *
 * @param { string } text text that goes in the button
 * @param { boolean } disabled wether or not to disable button
 * @param { function } onBtnClick callback to fire on button click
 * @param { align [deprecated] } string text alignment within button
 * @param { string } extraClass classes to add to button
 *
 * TODOS:
 *   see if we need align property, not sure it works
 *   change type to optional arrow direction and change type to pass type to button element
 */
function TextCTA({ text, disabled = false, onBtnClick, align, type, extraClass = '' }) {
  return (
    <button
      style={{ textAlign: align }}
      className={`c-btn c-btn--text clickable-link ${extraClass}`}
      disabled={disabled}
      onClick={onBtnClick}
    >
      {text} {insertArrow(type)}
    </button>
  );
}

export default TextCTA;



// WEBPACK FOOTER //
// ./src/layout/buttons/TextCTA.js